import React, { Fragment } from 'react';
import { Stack, Box, Grid, MenuItem, Typography, IconButton } from '@mui/material';
import { StyledDataGrid, StyledCard, StyledCardTitle, DataGridProps, CustomInputLabel, CustomTextField, InputProps, CustomButton, CustomSelect, SelectInputProps, FlexDiv } from '../../../../../../../custom/components';
import { EditIcon, DeleteIcon, DateFormat } from '../../../../../../../custom/constants';
import styles from '../../../../../../../custom/style.module.css';
import importStyles from './emailtemp.module.css';
import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import moment from 'moment';
import cookies from 'utils/cookies';
import BounceModal from './BounceModal';
import MailBounceIcon from '../../../../../../../assets/images/actionIcons/emailBounce.svg';

const EmailTemplate = (props) => {
  const { mails, onChangeMail, mailFields, mailFieldsErrors, swap, onRowMailClick, handleDeleteMail, editMail, saveMailFooter, onChangeFooter, footer, footerError, cc, ccErrors, onChangeCC, saveMailCC, bcc, bccErrors, onChangeBCC, saveMailBCC } = props;

  const SUB_TITLE_FS = '0.7rem';
  const SUB_TITLE_LH = 1;
  const SUB_TITLE_COLOR = '#000000c4';

  const PREVIEW_TYPOGRAPHY = {
    fontSize: '0.8rem',
    lineHeight: 1,
    color: '#000000c4',
    fontWeight: 400,
    marginBottom: '0.5rem',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  };

  const LABELPROPS = {
    minWidth: 200,
    fontSize: 'inherit',
    color: 'inherit',
  };

  const DATAPROPS = {
    fontSize: 'inherit',
    color: 'inherit',
  };

  const mailColumns = [
    {
      field: 'type',
      headerName: 'Type',
      minWidth: 100,
      flex: 1
    },
    {
      field: 'name',
      headerName: 'Name',
      minWidth: 100,
      flex: 1
    },
    {
      field: 'value',
      headerName: 'Position',
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      minWidth: 80,
      flex: 0.5,
      renderCell: ({ id }) => {
        return (
          <Stack direction='row' spacing={2} justifyContent='space-between' width='100%'>
            {id > 0 && <ArrowUpward color='primary' className={importStyles.arrowIcon} onClick={() => { swap('up', id); }} />}
            {id < (mails?.length - 1) && <ArrowDownward color='primary' className={`${importStyles.arrowIcon} ${styles.mlauto}`} onClick={() => { swap('down', id); }} />}
          </Stack>
        );
      }
    },
    {
      field: 'action',
      headerName: 'Action',
      align: 'right',
      headerAlign: 'right',
      width: 90,
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({ id, row }) => {
        return (
          <Stack direction='row' spacing={2} justifyContent='flex-end' width='100%' className={styles.actionIcons}>
            {(row.type == 'Text' || row.type == 'Text SPL') && <EditIcon onClick={() => { onRowMailClick(row); }} />}
            <DeleteIcon type='button' onClick={(e) => { handleDeleteMail(id, e.target); }} />
          </Stack>
        );
      }
    },
  ];

  return (
    <div>
      <Grid container spacing={3} sx={{
        justifyContent: 'center',
        height: 'calc(100vh - 207px)'
      }}>
        <Grid item xs={12} md={10} lg={6} xl={6}>
          <StyledCard className={`${styles.h100}`}>
            <FlexDiv>
              <Stack direction='row' width={'100%'} justifyContent='space-between' alignItems='center' mb={2}>
                <div>
                  <StyledCardTitle>Mail Template</StyledCardTitle>
                  <Typography component='span' fontSize={SUB_TITLE_FS} lineHeight={SUB_TITLE_LH} color={SUB_TITLE_COLOR} pt={0.5}>
              Content below will be used as the email template</Typography>
                </div>
                <IconButton
                  title='Notify Mail Bounce' 
                  color='primary' 
                  onClick={() => props.handleOpen('bounce', null, null)}
                  disableRipple
                  className={styles.p0}
                >
                  <img src={MailBounceIcon} alt='Mail Bounce Icon' height={'auto'} width={35} />
                </IconButton>
              </Stack>
            </FlexDiv>
            <div className={styles.tableWrapper}>
              <form onSubmit={saveMailCC}>
                <Grid container spacing={1} mb={1}>
                  <Grid item xs>
                    <CustomInputLabel htmlFor='cc'>CC</CustomInputLabel>
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      id='cc'
                      name='cc'
                      type=''
                      value={cc}
                      onChange={onChangeCC}
                      error={ccErrors}
                    />
                  </Grid>
                  <Grid item xs='auto' display={'flex'}>
                    <CustomButton type='submit' variant='contained' className={`${importStyles.addBtn}`}>Save</CustomButton>
                  </Grid>
                </Grid>
              </form>
              <form onSubmit={saveMailBCC}>
                <Grid container spacing={1} mb={2}>
                  <Grid item xs>
                    <CustomInputLabel htmlFor='bcc'>BCC</CustomInputLabel>
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      id='bcc'
                      name='bcc'
                      type=''
                      value={bcc}
                      onChange={onChangeBCC}
                      error={bccErrors}
                    />
                  </Grid>
                  <Grid item xs='auto' display={'flex'}>
                    <CustomButton type='submit' variant='contained' className={`${importStyles.addBtn}`}>Save</CustomButton>
                  </Grid>
                </Grid>
              </form>
              <form onSubmit={editMail}>
                <Box>
                  <Grid container spacing={1}>
                    <Grid item xs>
                      <CustomInputLabel htmlFor='cc'>Body</CustomInputLabel>
                      <CustomSelect
                        {...SelectInputProps}
                        id='type'
                        name='type'
                        fullWidth
                        value={mailFields.type || ''}
                        onChange={onChangeMail}
                        error={mailFieldsErrors.type}
                      >
                        <MenuItem value=''>Select Field</MenuItem>
                        <MenuItem value='Pieces'>Pieces</MenuItem>
                        <MenuItem value='Weight'>Weight</MenuItem>
                        <MenuItem value='O-D'>O-D</MenuItem>
                        <MenuItem value='Commodity'>Commodity</MenuItem>
                        <MenuItem value='Flight Number'>Flight Number</MenuItem>
                        <MenuItem value='Arrival Date'>Arrival Date</MenuItem>
                        <MenuItem value='Storage Starts'>Storage Starts</MenuItem>
                        <MenuItem value='Storage Cost'>Storage Cost</MenuItem>
                        <MenuItem value='Custom Status'>Customs Status</MenuItem>
                        <MenuItem value='Pick Up Status'>Pick Up Status</MenuItem>
                        <MenuItem value='Text'>Text</MenuItem>
                        <MenuItem value='Text SPL'>Conditional Text - SPL</MenuItem>
                      </CustomSelect>
                    </Grid>
                    {(mailFields.type === 'Text' || mailFields.type === 'Text SPL') && (
                      <Grid item xs={12}>
                        <CustomInputLabel htmlFor='name'>Name</CustomInputLabel>
                        <CustomTextField
                          {...InputProps}
                          fullWidth
                          id='name'
                          name='name'
                          value={mailFields.name}
                          onChange={onChangeMail}
                          error={mailFieldsErrors.name}
                          helperText={mailFieldsErrors.name}
                        />
                      </Grid>
                    )}
                    {(mailFields.type === 'Text' || mailFields.type === 'Text SPL') && (
                      <Grid item xs={12}>
                        <CustomInputLabel htmlFor='value'>Value</CustomInputLabel>
                        <CustomTextField
                          {...InputProps}
                          fullWidth
                          id='value'
                          name='value'
                          value={mailFields.value}
                          onChange={onChangeMail}
                          error={mailFieldsErrors.value}
                        />
                      </Grid>
                    )}
                    {mailFields.type === 'Text SPL' && (
                      <Grid item xs={12}>
                        <CustomInputLabel htmlFor='value'>Applied to SPL (Enter multiple SPL codes separated by commas)</CustomInputLabel>
                        <CustomTextField
                          {...InputProps}
                          fullWidth
                          id='condition_spl'
                          name='condition_spl'
                          value={mailFields.condition_spl}
                          onChange={onChangeMail}
                          error={mailFieldsErrors.condition_spl}
                        />
                      </Grid>
                    )}
                    <Grid item xs={mailFields.type?.includes('Text') ? 12 : 'auto'} display={'flex'}>
                      <CustomButton type='submit' variant='contained' className={`${importStyles.addBtn} ${mailFields.type?.includes('Text') ? styles.mt2 : ''}`}>Add</CustomButton>
                    </Grid>
                  </Grid>
                </Box>
              </form>
              <Box className={`${styles.tableOuter}`} mt={2}>
                <StyledDataGrid
                  {...DataGridProps}
                  rows={mails}
                  columns={mailColumns}
                  param={mails?.length}
                  getRowId={(row) => mails.findIndex((item) => JSON.stringify(item) === JSON.stringify(row))}
                />
              </Box>
              <form onSubmit={saveMailFooter}>
                <Grid container spacing={2} mt={1}>
                  <Grid item xs>
                    <CustomInputLabel htmlFor='footer'>Footer</CustomInputLabel>
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      id='footer'
                      name='footer'
                      type=''
                      value={footer}
                      onChange={onChangeFooter}
                      error={footerError}
                    />
                  </Grid>
                  <Grid item xs={'auto'} display={'flex'}>
                    <CustomButton type='submit' variant='contained' className={`${importStyles.addBtn}`}>Save</CustomButton>
                  </Grid>
                </Grid>
              </form>
            </div>
          </StyledCard>
        </Grid>
        <Grid item xs={12} md={10} lg={6} xl={6}>
          <StyledCard className={`${styles.h100} ${importStyles.emailPreviewCard}`} >
            <FlexDiv><StyledCardTitle>Mail Preview</StyledCardTitle></FlexDiv>
            <Typography component='span' fontSize={SUB_TITLE_FS} lineHeight={SUB_TITLE_LH} color={SUB_TITLE_COLOR} pt={0.5} mb={3}>
              The email content will match the preview shown.</Typography>
            <Stack className={importStyles.emailPreview} flex={'auto'} height={'100%'}>
              <Typography component='span' {...PREVIEW_TYPOGRAPHY}>
                Dear Customer,</Typography>
              <Typography component='span' {...PREVIEW_TYPOGRAPHY}>
                A shipment consigned to you has arrived at {cookies.get('station_code')} - Lufthansa Cargo.</Typography>
              <Stack mt={3}>

                {mails?.map((mail, index) => (
                  <Fragment key={index}>
                    <Typography component='div' {...PREVIEW_TYPOGRAPHY}>
                      <Typography {...LABELPROPS}>{(mail.type.toLowerCase() === 'text' || mail.type.toLowerCase() === 'text spl') ? mail.name : mail.type} </Typography>
                      <Typography {...DATAPROPS}> : &nbsp;
                        {(mail.type.toLowerCase() === 'text' || mail.type.toLowerCase() === 'text spl')
                          ? mail.value
                          : mail.type.toLowerCase() === 'pieces'
                            ? '14 pcs'
                            : mail.type.toLowerCase() === 'weight'
                              ? '1105.0K'
                              : mail.type.toLowerCase() === 'o-d'
                                ? 'MIA-HKG'
                                : mail.type.toLowerCase() === 'commodity'
                                  ? 'SHIP SPARE'
                                  : mail.type.toLowerCase() === 'flight number'
                                    ? 'EK213'
                                    : mail.type.toLowerCase() === 'custom status'
                                      ? '1C 25MAY26'
                                      : mail.type.toLowerCase() === 'pick up status'
                                        ? 'Ready for Pick Up 23MAY26 12:00'
                                        : mail.type.toLowerCase() === 'arrival date'
                                          ? moment().format(DateFormat).toUpperCase()
                                          : mail.type.toLowerCase() === 'storage starts'
                                            ? moment().format(DateFormat).toUpperCase()
                                            : 'N/A'}
                      </Typography>
                    </Typography>
                  </Fragment>
                ))}

              </Stack>
              <Stack mt={2}>
                <Typography component='p' {...PREVIEW_TYPOGRAPHY}>
                  Charges Due
                </Typography>
                <Typography component='p' {...PREVIEW_TYPOGRAPHY}>
                  ——————————
                </Typography>
                <Typography component='div' {...PREVIEW_TYPOGRAPHY}>
                  <Typography {...LABELPROPS}>Import Fee: </Typography>
                  <Typography {...DATAPROPS}> : &nbsp;$ 175 </Typography>
                </Typography>
                <Typography component='div' {...PREVIEW_TYPOGRAPHY}>
                  <Typography {...LABELPROPS}>Storage Fee: </Typography>
                  <Typography {...DATAPROPS}> : &nbsp;$ 36550 </Typography>
                </Typography>
              </Stack>
              <Typography component='div' {...PREVIEW_TYPOGRAPHY} mt={3}>
                {footer}
              </Typography>
            </Stack>
          </StyledCard>
        </Grid>
      </Grid>

      {props.modal === 'bounce' &&
        <BounceModal
          modal={props.modal}
          bounce={props.bounce}
          bounceErrors={props.bounceErrors}
          onChangeBounce={props.onChangeBounce}
          saveMailBounce={props.saveMailBounce}
          bounceList={props.bounceList}
          onDeleteBounceEmail={props.onDeleteBounceEmail}
          onClose={props.handleClose}
        />
      }
    </div>
  );
};

export default EmailTemplate;